import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateGetChatList = {
  getChatList: { data: null, loading: false, error: null },
};

export const getChatList = createAsyncThunk('tariff/getChatList', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .get(`${process.env.REACT_APP_SERVER_API}/ai-chat/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        // Accept: '*/*',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        // Connection: 'keep-alive',
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetChatList = {
  [getChatList.pending]: (state) => {
    state.getChatList.loading = true;
  },
  [getChatList.fulfilled]: (state, action) => {
    state.getChatList.loading = false;
    state.getChatList.data = action.payload;
    state.getChatList.error = null;
  },
  [getChatList.rejected]: (state, action) => {
    state.getChatList.loading = false;
    state.getChatList.data = action?.payload;
    state.getChatList.error = true;
  },
};
